import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Dialog } from 'primereact/dialog';

import ButtonSp from '../../components/ButtonSp';
import DropdownSp from '../../components/DropdownSp';
import InputTextSp from '../../components/InputTextSp';
import InputTextareaSp from '../../components/InputTextareaSp';
import LabelSp from '../../components/LabelSp';
import { OPCOES_DIAS_TESTE, OPCOES_TIPO_CHAVE } from './util';

// Pede o contrato e o tipo da chave. Teste = banco do cliente copiado para simular um erro
// (ou implantacao): corre em paralelo a instalacao do cliente, vale 1 a 3 dias a partir da
// ativacao e exige o motivo (fica gravado com quem gerou).
function DialogoGerar(props) {
  DialogoGerar.propTypes = {
    onConfirm: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired,
  };

  const { onConfirm, onClose } = props;
  const [numeroContrato, setNumeroContrato] = useState('');
  const [diasTeste, setDiasTeste] = useState(0);
  const [motivoTeste, setMotivoTeste] = useState('');

  const teste = diasTeste > 0;
  const valido = numeroContrato.trim() !== '' && (!teste || motivoTeste.trim().length >= 5);

  const footer = (
    <div>
      <ButtonSp
        className="p-button-success"
        icon="pi pi-check"
        label="Gerar"
        disabled={!valido}
        onClick={() => onConfirm(numeroContrato.trim(), diasTeste, motivoTeste.trim())}
      />
      <ButtonSp
        className="p-button-secondary"
        icon="pi pi-times"
        label="Cancelar"
        onClick={onClose}
      />
    </div>
  );

  return (
    <Dialog
      closable={false}
      footer={footer}
      header="Gerar chave de instalação"
      visible
      modal
      style={{ minWidth: '320px', maxWidth: '560px', width: '95%' }}
      onHide={onClose}
    >
      <div className="p-grid p-fluid">
        <div className="p-col-12 p-sm-5">
          <LabelSp>Número do contrato</LabelSp>
          <InputTextSp
            autoFocus
            required
            value={numeroContrato}
            onChange={e => setNumeroContrato(e.target.value.replace(/\D/g, ''))}
          />
        </div>
        <div className="p-col-12 p-sm-7">
          <LabelSp>Tipo</LabelSp>
          <DropdownSp
            options={OPCOES_TIPO_CHAVE}
            value={teste ? 'teste' : 'normal'}
            onChange={e => setDiasTeste(e.value === 'teste' ? 1 : 0)}
          />
        </div>

        {teste ? (
          <>
            <div className="p-col-12 p-sm-5">
              <LabelSp>Duração</LabelSp>
              <DropdownSp
                options={OPCOES_DIAS_TESTE}
                value={diasTeste}
                onChange={e => setDiasTeste(e.value)}
              />
            </div>
            <div className="p-col-12">
              <LabelSp>Motivo do teste</LabelSp>
              <InputTextareaSp
                required
                rows={3}
                maxLength={255}
                placeholder="Ex.: cliente relatou erro no fechamento de caixa"
                value={motivoTeste}
                onChange={e => setMotivoTeste(e.target.value)}
              />
            </div>
            <div className="p-col-12" style={{ color: '#856404' }}>
              Para simular o cliente com o banco dele copiado. Não derruba a instalação do
              cliente e conta a partir da ativação. O sistema mostra a faixa &quot;modo de
              teste&quot; e para sozinho no fim do prazo.
            </div>
          </>
        ) : (
          <div className="p-col-12">
            Instalação do cliente: só uma por contrato (para reinstalar, revogue a atual).
          </div>
        )}
      </div>
    </Dialog>
  );
}

export default DialogoGerar;
